import budgetsApi from '../_api'
import i18n from '@/locales/'
import { segmentTrack } from '@/analytics/segment'
export default {
  fetchBudgets: async ({ getters, commit, dispatch }, pagination = true) => {
    if (getters.isCallingBudgets) return
    commit('setIsCallingBudgets', true)
    try {
      const page = getters.currentPage
      const filters = getters.filters
      const response = await budgetsApi.getBudgets(page, pagination, filters)
      const lastPage = response.headers['pagination-last-page']
      commit('setBudgets', response.data)
      commit('setBudgetsLastPage', lastPage)
      commit(
        'setBudgetsTotalItems',
        response.headers['pagination-total-items']
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'budgets_action_fetch_budgets_error' },
        { root: true }
      )
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  fetchBudget: async ({ getters, commit, dispatch }, budgetId) => {
    if (getters.isCallingBudgets) return
    commit('setIsCallingBudgets', true)
    try {
      const response = await budgetsApi.getBudget(budgetId)
      commit('setCurrentBudget', response.data)
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'budgets_fetch_budget_error' }, { root: true })
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  updateBudget: async ({ getters, commit, dispatch }, { budgetId, budgetUpdateInformation }) => {
    if (getters.isCallingBudgets || !budgetId || !budgetUpdateInformation) return
    try {
      commit('setIsCallingBudgets', true)
      const response = await budgetsApi.putBudget(budgetId, budgetUpdateInformation)
      commit('updateCurrentBudget', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('budgets_update_budget_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'budgets_update_budget_error' }, { root: true })
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  nextBudgetsPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingBudgets) return
    commit('incrementBudgetsCurrentPage')
    dispatch('fetchBudgets')
  },
  createBudget: async ({ getters, commit, dispatch }, budget) => {
    if (getters.isCallingBudgets) return
    commit('setIsCallingBudgets', true)
    try {
      if (budget.flow?.code) {
        delete budget.flow
      }

      const response = await budgetsApi.postBudget(budget)
      commit('addBudget', response.data)
      dispatch('SnackBars/addSuccess', i18n.t('budget_action_create_budget_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'budgets_action_create_budget_error' }, { root: true })
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  updateUserMemberBudget: async ({ getters, commit, dispatch }, updatedUserMemberBudget) => {
    if (getters.isCallingBudgets) return
    commit('setIsCallingBudgets', true)
    try {
      const { id } = updatedUserMemberBudget
      const response = await budgetsApi.putUserBudgetsUser(id, updatedUserMemberBudget)
      commit('updateBudgetUserMember', response.data)
      segmentTrack('Budget user assignation changed', {
        budget_id: response.data.budget.id,
        assignee_user: `${response.data.user.firstName} ${response.data.user.lastName}`,
        assigned: updatedUserMemberBudget.assigned,
        budget_new_assigned_total: response.data.budget.assigned

      })
      if (getters.currentBudget) {
        commit('setIsCallingBudgets', false)
        await dispatch('fetchBudget', response.data.budget.id)
        commit('setIsCallingBudgets', true)
      }
      dispatch('SnackBars/addSuccess', i18n.t('budgets_action_update_user_assigned_budget_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'budgets_action_update_user_assigned_budget_error' }, { root: true })
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  setBudgetsFilters: async ({ commit, getters, dispatch }, filters) => {
    filters['order[id]'] = 'DESC'
    commit('setBudgetsFilters', filters)
    await dispatch('fetchBudgets')
  },
  archiveBudget: async ({ getters, commit, dispatch }, budgetId) => {
    if (getters.isCallingBudgets) return
    try {
      commit('setIsCallingBudgets', true)
      await budgetsApi.archiveBudget(budgetId)
      commit('setIsCallingBudgets', false)
      await dispatch('fetchBudget', budgetId)
      dispatch('SnackBars/addSuccess', i18n.t('budget_action_archive_budget_success'), { root: true })
    } catch (error) {
      dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'budgets_action_archive_budget_error' }, { root: true })
    } finally {
      commit('setIsCallingBudgets', false)
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }

}
